'use client';

import { VStack } from '@jaaq/hub-ui';
import Image from 'next/image';
import type { ReactElement, ReactNode } from 'react';
import { JaaqLogo } from './jaaq-logo';

type SignUpBackdropProps = {
  children: ReactNode;
};

/**
 * The shared sign-up backdrop – the photo, dark overlay and JAAQ logo – that
 * frames every step of the registration sheet (the account form and the email
 * verification). Each step supplies only its card as children.
 */
export const SignUpBackdrop = ({ children }: SignUpBackdropProps): ReactElement => (
  <div className="relative min-h-screen overflow-y-auto bg-border-strong">
    <Image src="/signup-bg.png" alt="" fill className="object-cover" priority />
    <div className="absolute inset-0 bg-black/20" aria-hidden="true" />

    <VStack
      align="center"
      justify="center"
      gap={6}
      className="relative z-10 min-h-screen px-4 py-12"
    >
      <JaaqLogo />
      {children}
    </VStack>
  </div>
);
